// eslint-disable-next-line import/no-cycle
import {
  GET_USERS,
  DELETE_USER,
  UPDATE_USER,
  CREATE_USER,
  USER_SUCCESS,
  USER_ERROR,
  USERS,
} from '../actions';

export const getUsers = (filter) => {
  return {
    type: GET_USERS,
    payload: { filter },
  };
};

export const deleteUsers = (id, users) => {
  return {
    type: DELETE_USER,
    payload: { id, users },
  };
};

export const updateUser = (
  id,
  name,
  nationcode,
  mobile,
  // email,
  // sheba,
  role,
  limit,
  areas,
  users,
  filter,
  callbackSuccess
) => {
  return {
    type: UPDATE_USER,
    payload: {
      id,
      name,
      nationcode,
      mobile,
      // email,
      // sheba,
      role,
      limit,
      areas,
      users,
      filter,
      callbackSuccess
    },
  };
};

export const createUser = (
  name,
  nationcode,
  mobile,
  // email,
  // sheba,
  role,
  limit,
  areas,
  users,
  filter,
  callbackSuccess
) => {
  return {
    type: CREATE_USER,
    payload: {
      name,
      nationcode,
      mobile,
      // email,
      // sheba,
      role,
      limit,
      areas,
      users,
      filter,
      callbackSuccess
    },
  };
};

export const setUsers = (users) => {
  return {
    type: USERS,
    payload: users,
  };
};

export const userSuccess = (message) => ({
  type: USER_SUCCESS,
  payload: { message },
});
export const userError = (message) => ({
  type: USER_ERROR,
  payload: { message },
});
